(() => {
  const decode = (value) => value.replace(/&amp;/gi, '&').trim();
  const approved = (raw, kind) => {
    const candidates = [raw.trim()];
    if (kind === 'embed') {
      for (const match of raw.matchAll(/(?:\bsrc|\bcite|\bdata-instgrm-permalink)\s*=\s*["']([^"']+)["']/gi)) candidates.push(decode(match[1]));
    }
    for (const candidate of candidates) {
      let url;
      try { url = new URL(candidate); } catch { continue; }
      if (url.protocol !== 'https:' || url.username || url.password || url.port) continue;
      const host = url.hostname.toLowerCase();
      let id;
      if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com', 'youtu.be'].includes(host)) {
        id = host === 'youtu.be' ? url.pathname.slice(1) : url.searchParams.get('v') || url.pathname.match(/^\/(?:embed|shorts)\/([\w-]+)\/?$/)?.[1];
        if (/^[\w-]{11}$/.test(id || '')) return { src: `https://www.youtube-nocookie.com/embed/${id}`, shape: 'wide' };
      }
      if (['vimeo.com', 'www.vimeo.com', 'player.vimeo.com'].includes(host)) {
        id = url.pathname.match(/^\/(?:video\/)?(\d+)\/?$/)?.[1];
        if (id) {
          const hash = url.searchParams.get('h');
          return { src: `https://player.vimeo.com/video/${id}${hash && /^[a-z0-9]+$/i.test(hash) ? `?h=${hash}` : ''}`, shape: 'wide' };
        }
      }
      if (kind === 'embed' && ['tiktok.com', 'www.tiktok.com'].includes(host)) {
        id = url.pathname.match(/^\/(?:@[^/]+\/video|player\/v1)\/(\d+)\/?$/)?.[1];
        if (id) return { src: `https://www.tiktok.com/player/v1/${id}`, shape: 'portrait' };
      }
      if (kind === 'embed' && ['instagram.com', 'www.instagram.com'].includes(host)) {
        id = url.pathname.match(/^\/(?:p|reel|tv)\/([\w-]+)(?:\/embed)?\/?$/)?.[1];
        if (id) return { src: `https://www.instagram.com/p/${id}/embed/`, shape: 'social' };
      }
    }
    return null;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = approved;
  if (typeof document === 'undefined') return;
  const makeFrame = (result, title) => {
    const iframe = document.createElement('iframe');
    iframe.src = result.src;
    iframe.title = title || 'Article media';
    iframe.loading = 'lazy';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allow = 'encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    return iframe;
  };
  const initialize = (root) => {
    root.querySelectorAll('[data-bw-approved-media]:not([data-ready])').forEach((figure) => {
      figure.dataset.ready = 'true';
      const source = figure.querySelector('template');
      const result = approved(source?.content.textContent || '', figure.dataset.mediaKind);
      if (!result) return;
      figure.dataset.shape = result.shape;
      figure.querySelector('[data-media-status]')?.remove();
      source.replaceWith(makeFrame(result, figure.dataset.mediaTitle));
    });
  };
  // Native Content: a paragraph that contains only one approved URL becomes an embed.
  const autoEmbed = (root) => {
    const title = document.querySelector('.bw-article__header h1')?.textContent.trim();
    root.querySelectorAll('.bw-article__body p:not([data-bw-checked])').forEach((p) => {
      p.dataset.bwChecked = 'true';
      if (p.querySelector('img, iframe, video')) return;
      const text = p.textContent.replace(/ /g, ' ').trim();
      if (!/^https:\/\/\S+$/.test(text)) return;
      const links = p.querySelectorAll('a');
      if (links.length > 1 || (links.length === 1 && links[0].textContent.trim() !== text)) return;
      const result = approved(text, 'embed');
      if (!result) return;
      const figure = document.createElement('figure');
      figure.className = 'bw-article__auto-embed';
      figure.dataset.bwApprovedMedia = '';
      figure.dataset.ready = 'true';
      figure.dataset.shape = result.shape;
      figure.appendChild(makeFrame(result, title));
      p.replaceWith(figure);
    });
  };
  const run = (root) => { initialize(root); autoEmbed(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(document), { once: true });
  else run(document);
  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
